<template>
    <div>
        <div id="perkin-gabungan" class="card mb-1 shadow-none border border-1 ">
            <div class="card-header border-bottom mb-1">
                <div class="card-title">
                    <span class="text-primary text-uppercase">
                        Perkin Gabungan
                    </span>
                </div>
            </div>
            <div class="card-body overflow-auto">
                <div class="mb-2">
                    <div class="text-nowrap mb-25 d-flex justify-content-start">
                        <span class="align-text-top font-small-5">
                            {{ formDatas.kolok + ' - ' + formDatas.nalok }}</span>
                    </div>
                </div>
                <b-overlay :show="loadingData" variant="light" opacity="0.85" blur="2px" rounded="sm">
                    <div class="overflow-auto">
                        <table class="table table-bordered table-hover-cell">
                            <thead class="table-primary font-weight-bolder">
                                <tr style="font-size: 16px;">
                                    <td class="text-center" style="min-width: 275px;">KEGIATAN</td>
                                    <td colspan="2" class="text-center">TW I (5%)</td>
                                    <td colspan="2" class="text-center">TW II (25%)</td>
                                    <td colspan="2" class="text-center">TW III (55%)</td>
                                    <td colspan="2" class="text-center">TW IV (100%)</td>
                                    <td colspan="2" class="text-center" style="min-width: 200px;">TW I - 2025</td>
                                </tr>
                            </thead>
                            <tbody style="font-size: 12px;" class="text-right">
                                <!-- Start Persiapan -->
                                <tr>
                                    <td class="font-weight-bolder">Persiapan (5%)</td>
                                    <td id="persiapan_tw_1" colspan="2">{{ perkinData.persiapan_tw_1 }}%</td>
                                    <td id="persiapan_tw_2" colspan="2">{{ perkinData.persiapan_tw_2 }}%</td>
                                    <td id="persiapan_tw_3" colspan="2">{{ perkinData.persiapan_tw_3 }}%</td>
                                    <td id="persiapan_tw_4" colspan="2">{{ perkinData.persiapan_tw_4 }}%</td>
                                    <td id="persiapan_tw_5" colspan="2">{{ perkinData.persiapan_tw_5 }}%</td>
                                </tr>
                                <!-- End Persiapan -->
                                <!-- Start Pelaksanaan -->
                                <tr>
                                    <td class="font-weight-bolder border-row">Pelaksanaan (85%)</td>
                                    <td style="width: 150px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw1 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw1 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_1">{{ perkinData.pelaksanaan_tw_1 }}%</td>
                                    <td style="width: 150px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw2 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw2 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_2">{{ perkinData.pelaksanaan_tw_2 }}%</td>
                                    <td style="width: 150px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw3 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw3 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_3">{{ perkinData.pelaksanaan_tw_3 }}%</td>
                                    <td style="width: 150px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw4 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw4 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_4">{{ perkinData.pelaksanaan_tw_4 }}%</td>
                                    <td style="width: 150px;">
                                        <div>
                                            {{ perkinData.pelaksanaan_selesai_inven_tw5 }}
                                        </div>
                                        <div class="bmd-overline">{{ perkinData.pelaksanaan_total_bmd_tw5 }}</div>
                                    </td>
                                    <td id="pelaksanaan_tw_5">{{ perkinData.pelaksanaan_tw_5 }}%</td>
                                </tr>
                                <!-- End Pelaksanaan -->
                                <!-- Start Pelaporan -->
                                <tr>
                                    <td rowspan="3" class="font-weight-bolder">Pelaporan (10%)</td>
                                    <td id="pelaporan_tw1" colspan="2">{{ perkinData.pelaporan_tw1 }}%</td>
                                    <td id="pelaporan_tw2" colspan="2">{{ perkinData.pelaporan_tw2 }}%</td>
                                    <td id="pelaporan_tw3" colspan="2">{{ perkinData.pelaporan_tw3 }}%</td>
                                    <td id="pelaporan_tw4" colspan="2">{{ perkinData.pelaporan_tw4 }}%</td>
                                    <td id="pelaporan_tw5" colspan="2">{{ perkinData.pelaporan_tw5 }}%</td>
                                </tr>
                                <!-- End Pelaporan -->
                            </tbody>
                            <tfoot class="bg-secondary" style="font-weight: bolder;">
                                <tr class="text-white text-right">
                                    <td>Akumluasi Pembobotan</td>
                                    <td id="akumulasi_bobot_tw_1" colspan="2">{{ perkinData.akumulasi_bobot_tw_1 }}%</td>
                                    <td id="akumulasi_bobot_tw_2" colspan="2">{{ perkinData.akumulasi_bobot_tw_2 }}%</td>
                                    <td id="akumulasi_bobot_tw_3" colspan="2">{{ perkinData.akumulasi_bobot_tw_3 }}%</td>
                                    <td id="akumulasi_bobot_tw_4" colspan="2">{{ perkinData.akumulasi_bobot_tw_4 }}%</td>
                                    <td id="akumulasi_bobot_tw_5" colspan="2">{{ perkinData.akumulasi_bobot_tw_5 }}%</td>
                                </tr>
                                <tr class="text-white text-right">
                                    <td>Akumluasi Per-TW
                                        <sup><feather-icon icon="InfoIcon" class="text-white" size="10"
                                                v-b-tooltip.hover.right
                                                title="Akumulasi Bobot dibagi Bobot TW dikali 100%" /></sup>
                                    </td>
                                    <td id="akumulasi_pertw_tw_1" colspan="2">{{ perkinData.akumulasi_pertw_tw_1 }}%</td>
                                    <td id="akumulasi_pertw_tw_2" colspan="2">{{ perkinData.akumulasi_pertw_tw_2 }}%</td>
                                    <td id="akumulasi_pertw_tw_3" colspan="2">{{ perkinData.akumulasi_pertw_tw_3 }}%</td>
                                    <td id="akumulasi_pertw_tw_4" colspan="2">{{ perkinData.akumulasi_pertw_tw_4 }}%</td>
                                    <td id="akumulasi_pertw_tw_5" colspan="2">{{ perkinData.akumulasi_pertw_tw_5 }}%</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </b-overlay>
                <div class="d-flex justify-content-between my-2 ">
                    <div>
                        <span class="font-weight-bold font-size-xl">Rincian Perkin Gabungan</span>
                    </div>
                    <div class="card-toolbar">
                        <div>
                            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="md"
                                @click="cetakExcelPerkin">
                                <feather-icon icon="PrinterIcon" class="mr-50" />
                                <span class="align-middle">Download Excel</span>
                            </b-button>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <b-form-group>
                            <b-form-input id="search-data-bmd" v-model="formFilterTable.cari"
                                placeholder="Pencarian kolok, ketik kata kunci pencarian lalu tekan enter" type="text"
                                class="d-inline-block" @keyup.enter="handleSearch" />
                        </b-form-group>
                    </div>
                    <vue-good-table theme="polar-bear" :columns="columns" :rows="rows" :pagination-options="{
                        enabled: true, perPage: row, jumpFirstOrLast: true,
                    }" :totalRows="totalRecords" :isLoading="isLoadingTable" mode="remote"
                        @on-sort-change="onSortChange">
                        <template slot="table-row" slot-scope="props">
                            <div v-if="props.column.field == 'jenis_perkin'">
                                <span class="text-capitalize">{{ props.formattedRow[props.column.field] }}</span>
                            </div>
                            <div v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </div>
                        </template>
                        <template slot="pagination-bottom">
                            <div class="d-flex justify-content-between flex-wrap">
                                <div class="d-flex align-items-center mb-0 mt-1">
                                    <span class="text-nowrap"> Menampilkan 1 hingga </span>
                                    <b-form-select v-model="row" :options="['10', '25', '50']" class="mx-1"
                                        @input="handlePageChange" />
                                    <span class="text-nowrap">
                                        dari {{ totalRecords }} entri
                                    </span>
                                </div>
                                <div>
                                    <b-pagination :value="1" :total-rows="totalRecords" :per-page="row" first-number
                                        last-number align="right" prev-class="prev-item" next-class="next-item"
                                        class="mt-1 mb-0" @change="handleChangePage">
                                        <template #prev-text>
                                            <feather-icon icon="ChevronLeftIcon" size="18" />
                                        </template>
                                        <template #next-text>
                                            <feather-icon icon="ChevronRightIcon" size="18" />
                                        </template>
                                    </b-pagination>
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect, onMounted } from '@vue/composition-api'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from "vue-good-table";
import perkin from "@/composables/b/perkin";

export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        perkinData: {
            type: Object,
            required: true,
        },
        loadingData: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        VueGoodTable
    },
    directives: {
        Ripple,
    },
    methods: {
    },
    setup(props, context) {
        const g = context.root;
        const formDatas = ref(props.fD);
        /* Dataset */

        const isLoadGetData = ref(false);
        //variable untuk table
        const start = ref(0);
        const rows = ref([]);
        const row = ref(10);
        const totalRecords = ref(0);
        const sortColumn = ref("");
        const order = ref("");
        const isLoadingTable = ref(false);
        const formFilterTable = ref({
            filter_kolok_parent: props.fD.kolok,
            limit: row.value,
            start: start.value,
            cari: '',
        });

        const filterValue = ref({
            filter_kolok_parent: null,
            limit: row.value,
            start: start.value,
            cari: '',
        })
        const getData = () => {
            isLoadingTable.value = true;
            filterValue.value.filter_kolok_parent = props.fD.kolok;
            filterValue.value.jenis_perkin = 'individu';

            perkin.getData(g, filterValue.value).then(resp => {
                if (resp.success) {
                    rows.value = resp.rows;
                    totalRecords.value = resp.totalRows;
                } else {
                    rows.value = [];
                    totalRecords.value = 0;
                }
                isLoadingTable.value = false;
            }).catch((err) => {
                console.log(err)
                isLoadingTable.value = false;
            });
        };
        getData();

        const handleSearch = (searching) => {
            filterValue.value.start = 0;
            filterValue.value.cari = formFilterTable.value.cari;
            getData();
        };

        const handlePageChange = (length) => {
            filterValue.value.limit = length;
            getData();
        };

        const handleChangePage = (page) => {
            filterValue.value.start = (page - 1) * row.value;
            getData();
        };

        const onSortChange = (params) => {
            sortColumn.value = params[0].field;
            order.value = params[0].type;
            getData();
        };

        /* Cetak */
        const cetakExcelPerkin = () => {
            const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna-b/perkin/excel?tahun=' + props.fD.tahun + '&filter_kolok_parent=' + props.fD.kolok + '&filter_kolok=semua' + '&jenis_perkin=individu' + '&cari=' + formFilterTable.value.cari; // Replace with your specific link
            window.open(linkToOpen, '_blank');
        }

        return {
            formDatas,
            getData,
            /* Table */
            formFilterTable,
            filterValue,
            handleSearch,
            handlePageChange,
            handleChangePage,
            onSortChange,
            rows,
            start,
            row,
            totalRecords,
            sortColumn,
            order,
            isLoadingTable,

            /* Cetak */
            cetakExcelPerkin
        }
    },
    computed: {
    },


    data() {
        return {
            required,
            columns: [
                {
                    label: "Kolok",
                    field: "kolok",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nalok",
                    field: "nalok",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Jenis Perkin",
                    field: "jenis_perkin",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW I",
                    field: "result_tw1",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW II",
                    field: "result_tw2",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW III",
                    field: "result_tw3",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW IV",
                    field: "result_tw4",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW I - 2025",
                    field: "result_tw5",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1 text-center',
                    sortable: false,
                },
            ],
        }
    },
}
</script>
<style lang="scss" scoped>
.table-hover-cell tbody tr td:hover {
    background-color: #d9d9d9;
}

.bmd-overline {
    text-decoration: overline;
}
</style>